export const BILLING_CODE_DEPARTMENTS = [
  'Ocean Import',
  'Ocean Export',
  'Air Import',
  'Air Export',
  'Warehouse',
  '3PL',
  'Other',
];
